// extracted by mini-css-extract-plugin
export default {"ExpressCourses":"Courses_ExpressCourses__EMUDW","ExpressCourses__CoursesList":"Courses_ExpressCourses__CoursesList__eN9m2"};